// extracted by mini-css-extract-plugin
export default {"root":"tiny-mce-editor_root__LXurA","loader":"tiny-mce-editor_loader__5PDPf"};